import { Offer } from "@comparaonline/offers-models";
import { isInsuranceByKm } from "../../../models/product";

export const getSupportsCoupon = (offer: Offer): boolean => {
  if (!offer) {
    return false;
  }

  const hasPromotion = Boolean(offer.promotion && offer.promotion.code);
  return !(isInsuranceByKm(offer.product) || hasPromotion);
};
